import { render, staticRenderFns } from "./rilibaoindex.vue?vue&type=template&id=35c82c26&scoped=true&"
import script from "./rilibaoindex.vue?vue&type=script&lang=js&"
export * from "./rilibaoindex.vue?vue&type=script&lang=js&"
import style0 from "./rilibaoindex.vue?vue&type=style&index=0&id=35c82c26&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c82c26",
  null
  
)

export default component.exports